import $ from "jquery"
import TemplateView from "../../../TemplateView";
import StatusHeader from "./StatusHeader";
import {getStatusClassByType} from "../../../workflowStatus/utils"
import {WorkflowStatusType} from "../../../workflowStatus/constants";
import messageResource from '../../../messageResource'

export default class StatusHeadersPanel extends TemplateView {
    constructor() {
        super()

        this.state = {
            statuses: []
        }

        this.onStatePropertyDeeplyChanged("statuses", statuses => this._updateStatuses(statuses))
    }

    templateHtml() {
        return "<div class='statusHeadersPanel'></div>"
    }

    _updateStatuses(statuses) {
        this.$el.empty()

        statuses.forEach(({name, count, type, colorId}) => {
            new StatusHeader({name, count, type, colorId}).init(this.$el)
        })

        this._appendFirstStatusMarker(WorkflowStatusType.OPEN, 'task.list.kanban.status_headers_panel.open_tasks')
        this._appendFirstStatusMarker(WorkflowStatusType.COMPLETED, 'task.list.kanban.status_headers_panel.completed_tasks')
        $('.statusHeadersPanel').find('.statusHeader.' + getStatusClassByType(WorkflowStatusType.OPEN)).last().addClass("lastOpen")
    }

    _appendFirstStatusMarker = (statusType, markerTextKey) => {
        const statusClass = getStatusClassByType(statusType)
        const markerText =  messageResource.getEscapedMessage(markerTextKey)
        const $firstStatusHeader = $('.statusHeadersPanel').find('.' + statusClass).first()
        $firstStatusHeader.append("<div class='firstStatusMarker'>" + markerText + "</div>")
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/components/StatusHeadersPanel.js